/* VIVA63 LumiDeck — pill tabs + centred coverflow (tabs/arrows/swipe/keys). */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.vivaLdReady) return;
    root.dataset.vivaLdReady = '1';

    var stage = root.querySelector('[data-viva-ld-stage]');
    var track = root.querySelector('[data-viva-ld-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-viva-ld-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-viva-ld-tab]'));
    var tabsEl = root.querySelector('[data-viva-ld-tabs]');
    var tabsPrev = root.querySelector('[data-viva-ld-tabs-prev]');
    var tabsNext = root.querySelector('[data-viva-ld-tabs-next]');
    var prev = root.querySelector('[data-viva-ld-prev]');
    var next = root.querySelector('[data-viva-ld-next]');
    if (!stage || !track || slides.length < 1) return;

    var current = 0;
    var count = slides.length;

    function setButtonState(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function layout() {
      var s = slides[current];
      var stageW = stage.clientWidth;
      var x = stageW / 2 - (s.offsetLeft + s.offsetWidth / 2);
      track.style.setProperty('--viva-ld-x', x + 'px');
    }

    function syncTabsArrows() {
      if (!tabsEl || !tabsPrev || !tabsNext) return;
      var max = tabsEl.scrollWidth - tabsEl.clientWidth;
      tabsPrev.disabled = tabsEl.scrollLeft <= 2;
      tabsNext.disabled = tabsEl.scrollLeft >= max - 2;
    }

    function go(i, focusTab) {
      i = Math.max(0, Math.min(i, count - 1));
      current = i;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });
      tabs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && tabsEl) {
          // keep active pill visible inside the scrollable tab strip
          var left = t.offsetLeft - (tabsEl.clientWidth - t.offsetWidth) / 2;
          tabsEl.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          if (focusTab) t.focus({ preventScroll: true });
        }
      });
      setButtonState(prev, i === 0);
      setButtonState(next, i === count - 1);
      layout();
      window.setTimeout(syncTabsArrows, 350);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.dataset.index, 10) || 0);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1, true); }
      });
    });
    slides.forEach(function (s) {
      s.addEventListener('click', function () {
        var i = parseInt(s.dataset.index, 10) || 0;
        if (i !== current) go(i);
      });
    });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    if (tabsPrev) tabsPrev.addEventListener('click', function () { go(current - 1); });
    if (tabsNext) tabsNext.addEventListener('click', function () { go(current + 1); });
    if (tabsEl) tabsEl.addEventListener('scroll', syncTabsArrows, { passive: true });

    // Swipe (touch / pointer)
    var startX = null;
    var startY = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX;
      startY = e.clientY;
    });
    stage.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        go(current + (dx < 0 ? 1 : -1));
      }
    });
    stage.addEventListener('pointercancel', function () { startX = startY = null; });

    var ro = 'ResizeObserver' in window ? new ResizeObserver(function () { layout(); syncTabsArrows(); }) : null;
    if (ro) ro.observe(stage);
    else window.addEventListener('resize', layout);

    // Images may change slide widths after load
    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', layout, { once: true });
    });

    go(0);
  }

  function boot() {
    document.querySelectorAll('[data-viva-ld]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
